import { ComponentProps, ReactNode } from 'react';

import { FiltersProviderWithLabels as FiltersProviderWithLabelsImpl } from '../../../Labels';
import { useOptionalPageBridgeProps } from '../../utils';
import { asPageWrapper } from '../composition';

export type PageFiltersProviderWithLabelsProps = Omit<
  ComponentProps<typeof FiltersProviderWithLabelsImpl>,
  'children' | 'storageKey'
> & { storageKey?: string };

const BridgedFiltersProviderWithLabels = ({
  storageKey,
  children,
  ...rest
}: PageFiltersProviderWithLabelsProps & { children: ReactNode }) => {
  const bridgeProps = useOptionalPageBridgeProps();
  const resolvedStorageKey = storageKey ?? bridgeProps?.descriptor.id ?? '';

  return (
    <FiltersProviderWithLabelsImpl storageKey={resolvedStorageKey} {...rest}>
      {children}
    </FiltersProviderWithLabelsImpl>
  );
};

export const FiltersProviderWithLabels = asPageWrapper(
  (_props: PageFiltersProviderWithLabelsProps): null => null,
  BridgedFiltersProviderWithLabels,
);
